import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
    Checkbox,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from '@mui/material'
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material'

const InsuranceListViewCard = ({ deleteBtn, color, path, order, setAlert }) => {
    const navigate = useNavigate()

    const { requested_for_user } = order

    const { city, state, zip } = requested_for_user

    return (
        <>
            <div>
                <List
                    sx={{
                        margin: 0,
                        padding: 0,
                    }}
                >
                    <ListItem
                        onClick={() => {
                            navigate(`../orders/detail/${order.ref_number}`, {
                                state: order,
                            })
                        }}
                        sx={{
                            backgroundColor: 'white',
                            padding: '15px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            display: 'flex',
                        }}
                        disablePadding
                    >
                        <ListItemIcon>
                            <Checkbox
                                tabIndex={-1}
                                disableRipple
                                icon={
                                    <CheckBoxOutlineBlank
                                        sx={{
                                            backgroundColor: '#F1F5F9',
                                            color: '#F1F5F9',
                                            borderRadius: 1,
                                        }}
                                    />
                                }
                                checkedIcon={
                                    <CheckBox
                                        sx={{
                                            backgroundColor: '#0F172A',
                                            color: '#0F172A',
                                            borderRadius: 1,
                                        }}
                                    />
                                }
                            />
                        </ListItemIcon>
                        <ListItemText
                            className="!flex-[2]"
                            primary={`${requested_for_user?.name}`}
                        />
                        <ListItemText
                            className="!flex-1 text-center"
                            primary={`${requested_for_user?.type}`}
                        />
                        <ListItemText
                            className="!flex-1 text-center"
                            primary={`${city?.name}, ${state?.name}, ${zip}`}
                        />
                        <ListItemText
                            className="!flex-1 text-center"
                            primary={`${order.status}`}
                        />
                        <ListItemText
                            className="!flex-1 text-center"
                            // primary={`(${order.requested_for_user.certificates.length}) Certificates`} // when done from backend then uncomment this line
                            primary={
                                order.status == 'Pending' || order.status == 'Accepted' 
                                    ? `(${order.requested_for_user.certificates.filter((f) => f.status !== 'Verified')?.length}) Certificates`
                                    : `(${order.verification_order_details.length}) Certificates`
                            }
                        />
                    </ListItem>
                </List>
            </div>
        </>
    )
}

export default InsuranceListViewCard
